module.exports = __webpack_public_path__ + "media/images/slide-2-8cc593f339d6c2095f48f0c27ccf58e9.jpg";